/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from "react";
import { Button, Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Header() {
const { t, i18n } = useTranslation();
const [isMenuOpen, setIsMenuOpen] = useState(false);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [isSearchOpen, setIsSearchOpen] = useState(false);
const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);

const toggleMenu = () => {
setIsMenuOpen(!isMenuOpen);
};

const toggleSidebar = () => {
setIsSidebarOpen(!isSidebarOpen);
};

const toggleSearch = () => {
setIsSearchOpen(!isSearchOpen);
};

const toggleProductsDropdown = () => {
setIsProductsDropdownOpen(!isProductsDropdownOpen);
};

const changeLanguage = (lng) => {
i18n.changeLanguage(lng);
};

const handleClick = () => {
window.scrollTo(0, 0);
setIsMenuOpen(false);
setIsSidebarOpen(false);
setIsSearchOpen(false);
};

return (
<>
  <div className="topbar topbar--three fixed-top">
    <div className="container">
      <div className="topbar__inner">
        <div className="topbar__left">
          <ul className="list-unstyled topbar__info">
            <li>
              <i className="icon-paper-plane"></i>
              <a href={`mailto:${t('info@seymenkimya.com')}`}>{t('info@seymenkimya.com')}</a>
            </li>
          </ul>
        </div>
        <div className="topbar__right">
          <ul className="list-unstyled topbar__info">
            <li>
              <i className="icon-time"></i>
              <span>Haftaiçi&nbsp; 08:30 - 18:30 & Ctsi &nbsp;08:30 - 14:00</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <header className="main-header main-header--three sticky-header sticky-header--normal fixed-top">
      <div className="main-header__bg" style={{backgroundImage: 'url(assets/images/backgrounds/main-header-3-bg.jpg)'}}>
      </div>
      <div className="main-header__container container">
        <div className="main-header__top">
          <div className="main-header__call text-white">
            <span className="main-header__call__icon fab fa-whatsapp text-white"></span>
            <div className="main-header__call__inner">
              <span className="main-header__call__tagline">Whatsapp hattı !</span>
              <a href="https://wa.me/905553735627" target="_blank" rel="noopener noreferrer"
                className="main-header__call__number">0 555 373 56 27</a>
            </div>

          </div>
          <div className="main-header__top__right">
            <div className="main-header__logo">
              <Link to="/" onClick={handleClick}>
              <img src="assets/images/Seymen-Logo.webp" alt={t('Seymen-Kimya')} width="171" />
              </Link>
            </div>
            <div className="main-header__call">
              <span className="main-header__call__icon icon-phone-call"></span>
              <div className="main-header__call__inner">
                <span className="main-header__call__tagline">Bize Ulaşın !</span>
                <a href="tel:+905553735627" className="main-header__call__number">0 555 373 56 27</a>
              </div>
            </div>
          </div>
        </div>
        <div className="main-header__inner">
          <button type="button" className="main-header__sidebar-btn sidebar-btn__toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <nav className="main-header__nav main-menu">
            <ul className="main-menu__list">

              <li>
                <Link to="/" onClick={handleClick}>{t('ANASAYFA')}</Link>
              </li>
              <li>
                <Link to="/kurumsal" onClick={handleClick}>{t('HAKKIMIZDA')}</Link>
              </li>
              <li className="dropdown">
                <Link to="/urunlerimiz" onClick={handleClick}>{t('ÜRÜNLERİMİZ')}</Link>
                <ul>
                  <li>
                    <Link to="/bulasikmakinedeterjanlari" onClick={handleClick}>{t('Bulaşık Makina Deterjanları')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ProductSimilarCamasirsulari" onClick={handleClick}>{t('Çamaşır Suları')}</Link>
                  </li>
                  <li>
                    <Link to="/productsimilarsivielsabunlari" onClick={handleClick}>{t('Sıvı El Sabunları')}</Link>
                  </li>
                  <li>
                    <Link to="/yuzeytemizlikmaddesi" onClick={handleClick}>{t('Yüzey Temizlik Maddesi')}</Link>
                  </li>
                  <li>
                    <Link to="/sanayitipiyagcozucu" onClick={handleClick}>{t('Sanayi Tipi Yağ Çözücü')}</Link>
                  </li>
                  <li>
                    <Link to="/kireccozucu" onClick={handleClick}>{t('Kireç Çözücü')}</Link>
                  </li>
                  <li>
                    <Link to="/wcbanyotemizleyici" onClick={handleClick}>{t('Wc Banyo Temizleyici')}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/iletisim" onClick={handleClick}>{t('İLETİŞİM')}</Link>
              </li>
            </ul>
          </nav>
          <div className="main-header__inner__right">
            <button type="button" className="mobile-nav__btn mobile-nav__toggler" onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>
            <Link to="/iletisim" className="main-header__contac-btn boskery-btn" onClick={handleClick}>
            <span className="boskery-btn__hover"></span>
            <span className="boskery-btn__hover"></span>
            <span className="boskery-btn__hover"></span>
            <span className="boskery-btn__hover"></span>
            <span className="boskery-btn__hover"></span>
            <span className="boskery-btn__hover"></span>
            <span className="boskery-btn__text">{t('İLETİŞİM')}</span>
            <i className="icon-paper-plane"></i>
            </Link>
          </div>
        </div>
      </div>
    </header>

  </div>
  {/* Mobile Navigation */}
  {isMenuOpen && (
  <div className={`mobile-nav__wrapper ${isMenuOpen ? 'expanded' : '' }`}>
    <div className="mobile-nav__overlay mobile-nav__toggler" onClick={toggleMenu}></div>
    <div className="mobile-nav__content">
      <span className="mobile-nav__close mobile-nav__toggler" onClick={toggleMenu}>
        <i className="fa fa-times"></i>
      </span>

      <div className="logo-box">
        <Link to="/" aria-label="logo image" onClick={handleClick}>
        <img src="assets/images/Beyaz-seymen-logo.webp" width="220" alt={t('Seymen-Kimya')} />
        </Link>
      </div>

      <nav className="mobile-nav__container">
        <ul className="mobile-nav__list" style={{
                listStyle: 'none',
                listStyleType: 'none',
                padding: 0,
                margin: 0,
                paddingLeft: 0,
                marginLeft: 0
              }}>
          <li style={{
                  listStyle: 'none',
                  listStyleType: 'none',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  paddingLeft: 0,
                  marginLeft: 0
                }}>
            <Link to="/" onClick={handleClick} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '15px 0',
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
            {t('ANASAYFA')}
            </Link>
          </li>
          <li style={{
                  listStyle: 'none',
                  listStyleType: 'none',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  paddingLeft: 0,
                  marginLeft: 0
                }}>
            <Link to="/hakkimizda" onClick={handleClick} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '15px 0',
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
            {t('HAKKIMIZDA')}
            </Link>
          </li>
          <li style={{
                  listStyle: 'none',
                  listStyleType: 'none',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  paddingLeft: 0,
                  marginLeft: 0
                }}>
            <div onClick={toggleProductsDropdown} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '15px 0',
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    cursor: 'pointer'
                  }}>
            {t('ÜRÜNLERİMİZ')}
            <span style={{color: '#10adad', fontSize: '22px', transform: isProductsDropdownOpen ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease'}}>›</span>
            </div>
            
            {isProductsDropdownOpen && (
              <ul style={{
                listStyle: 'none',
                padding: '0 0 0 20px',
                margin: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                borderRadius: '5px',
                marginTop: '10px'
              }}>
                <li style={{borderBottom: '1px solid rgba(255, 255, 255, 0.05)', padding: '10px 0', textTransform: 'uppercase'}}>
                  <Link to="/bulasikmakinedeterjanlari" onClick={handleClick} style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px',
                    opacity: 0.9,
                    textTransform: 'uppercase'
                  }}>
                    {t('Bulaşık Makina Deterjanları')}
                  </Link>
                </li>
                <li style={{borderBottom: '1px solid rgba(255, 255, 255, 0.05)', padding: '10px 0'}}>
                  <Link to="/ProductSimilarCamasirsulari" onClick={handleClick} style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px',
                    opacity: 0.9,
                    textTransform: 'uppercase'
                  }}>
                    {t('Çamaşır Suları')}
                  </Link>
                </li>
                <li style={{borderBottom: '1px solid rgba(255, 255, 255, 0.05)', padding: '10px 0'}}>
                  <Link to="/productsimilarsivielsabunlari" onClick={handleClick} style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px',
                    opacity: 0.9,
                    textTransform: 'uppercase'
                  }}>
                    {t('Sıvı El Sabunları')}
                  </Link>
                </li>
                <li style={{borderBottom: '1px solid rgba(255, 255, 255, 0.05)', padding: '10px 0'}}>
                  <Link to="/yuzeytemizlikmaddesi" onClick={handleClick} style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px',
                    opacity: 0.9,
                    textTransform: 'uppercase'
                  }}>
                    {t('Yüzey Temizlik Maddesi')}
                  </Link>
                </li>
                <li style={{borderBottom: '1px solid rgba(255, 255, 255, 0.05)', padding: '10px 0'}}>
                  <Link to="/sanayitipiyagcozucu" onClick={handleClick} style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px',
                    opacity: 0.9,
                    textTransform: 'uppercase'
                  }}>
                    {t('Sanayi Tipi Yağ Çözücü')}
                  </Link>
                </li>
                <li style={{borderBottom: '1px solid rgba(255, 255, 255, 0.05)', padding: '10px 0'}}>
                  <Link to="/kireccozucu" onClick={handleClick} style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px',
                    opacity: 0.9,
                    textTransform: 'uppercase'
                  }}>
                    {t('Kireç Çözücü')}
                  </Link>
                </li>
                <li style={{padding: '10px 0'}}>
                  <Link to="/wcbanyotemizleyici" onClick={handleClick} style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px',
                    opacity: 0.9,
                    textTransform: 'uppercase'
                  }}>
                    {t('Wc Banyo Temizleyici')}
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li style={{
                  listStyle: 'none',
                  listStyleType: 'none',
                  paddingLeft: 0,
                  marginLeft: 0
                }}>
            <Link to="/iletisim" onClick={handleClick} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '15px 0',
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
            {t('İLETİŞİM')}
            </Link>
          </li>
        </ul>
      </nav>
      <br />

      <ul className="mobile-nav__contact list-unstyled">
        <li>
          <i className="fa fa-envelope"></i>
          <a href={`mailto:${t('info@seymenkimya.com')}`}>{t('info@seymenkimya.com')}</a>
        </li>
        <li>
          <i className="fa fa-phone-alt"></i>
          <a href="tel:+905553735627">0 555 373 56 27</a>
        </li>
        <li>
          <i className="fa fa-phone-alt"></i>
          <a href="tel:+905393636862">0 539 363 6862</a>
        </li>
      </ul>
      <br />
      <div className="mobile-nav__social">
        <a href="https://www.instagram.com/seymenkimya/" aria-hidden="true" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram"></i>
          <span className="sr-only">Instagram</span>
        </a>
      </div>
    </div>
  </div>
  )}
  {/* Search Popup */}
  {isSearchOpen && (
  <div className="search-popup">
    <div className="search-popup__overlay search-toggler" onClick={toggleSearch}></div>
    <div className="search-popup__content">
      <form role="search" method="get" className="search-popup__form" action="#">
        <input type="text" id="search" placeholder={t('search_placeholder')} />
        <button type="submit" aria-label="search submit" className="boskery-btn">
          <span className="boskery-btn__hover"></span>
          <span className="boskery-btn__hover"></span>
          <span className="boskery-btn__hover"></span>
          <span className="boskery-btn__hover"></span>
          <span className="boskery-btn__hover"></span>
          <span className="boskery-btn__hover"></span>
          <span className="boskery-btn__text">{t('search')}</span>
          <i className="icon-search"></i>
        </button>
      </form>
    </div>
  </div>
  )}
  {/* Sidebar */}
  {isSidebarOpen && (
  <aside className={`sidebar-one ${isSidebarOpen ? 'active' : '' }`}>
    <div className="sidebar-one__overlay sidebar-btn__toggler" onClick={toggleSidebar}></div>
    <div className="sidebar-one__content">
      <span className="sidebar-one__close sidebar-btn__toggler" onClick={toggleSidebar}>
        <i className="fa fa-times"></i>
      </span>
      <div className="sidebar-one__logo sidebar-one__item">
        <Link to="/" aria-label="logo image" onClick={handleClick}>
        <img src="assets/images/Beyaz-seymen-logo.webp" width="220" alt={t('company_name')} />
        </Link>
      </div>
      <div className="sidebar-one__about sidebar-one__item">
        <p className="sidebar-one__about__texts">
          {t('Seymen Kimya, kaliteli hammadde ve ileri teknolojiyle uluslararası standartlarda, çevreye duyarlı ve kullanıcı sağlığını önceleyen temizlik ve kimyasal ürünler üretir.')}
        </p>
      </div>
      <div className="sidebar-one__info sidebar-one__item">
        <h4 className="sidebar-one__title">{t('İLETİŞİM')}</h4>
        <ul className="sidebar-one__info__list">
          <li>
            <span className="icon-maps-and-flags"></span>
            <address>Bursa Gıda Toptancılar Sitesi,
              <br />
              Ertuğrul Mh. 105. Sk. No:2, 16120 Nilüfer/Bursa</address>
          </li>
          <li>
            <span className="icon-paper-plane"></span>
            <a href={`mailto:${t('info@seymenkimya.com')}`}>{t('info@seymenkimya.com')}</a>
          </li>
          <li>
            <span className="icon-phone-call"></span>
            <a href="tel:+905553735627">0 555 373 56 27</a>
          </li>
          <li>
            <span className="icon-phone-call"></span>
            <a href="tel:+905393636862">0 539 363 68 62</a>
          </li>
        </ul>
      </div>
      <div className="sidebar-one__social sidebar-one__item">
        <a href="https://www.instagram.com/seymenkimya/" aria-hidden="true" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram"></i>
          <span className="sr-only">Instagram</span>
        </a>
      </div>
    </div>
  </aside>
  )}

  {/* Back to Top Button */}
  <button type="button" className="back d-flex align-items-center justify-content-center active" onClick={()=>
    window.scrollTo({ top: 0, behavior: 'smooth' })}
    aria-label="Back to top"
    >
    <i className="fas fa-arrow-up"></i>
    <svg className="whatsapp-button__circle" width="100%" height="100%" viewBox="-1 -1 102 102">
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
    </svg>
  </button>

  {/* WhatsApp Button */}
  <a href="https://wa.me/905553735627" className="whatsapp-button" target="_blank" rel="noopener noreferrer"
    aria-label="WhatsApp">
    <i className="fab fa-whatsapp"></i>
    <svg className="whatsapp-button__circle" width="100%" height="100%" viewBox="-1 -1 102 102">
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
    </svg>
  </a>

</>
);
}

export default Header;